import isValidDate from '../../../../shared/utils/isValidDate';

export default function prepareFilterParams(logisticTaskId, filters, rowsPerPage, page) {
  const result = { 'taskId.equals': logisticTaskId, size: rowsPerPage, page, sort: ['priority'] };

  if (filters.priorities?.length) result['priority.in'] = filters.priorities.map((item) => item.value);

  if (filters.statuses?.length) result['status.in'] = filters.statuses.map((item) => item.value);

  if (isValidDate(filters?.createdDate)) result['createdDate.greaterThanOrEqual'] = filters.createdDate.toISOString();

  if (isValidDate(filters?.endTime)) result['endTime.lessThanOrEqual'] = filters.endTime.toISOString();
  else result['endTime.greaterThanOrEqual'] = new Date().toISOString();

  return result;
}
